import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the getPGN method.
 */
export function createGetPGN(context: API.Context) {
  /**
   * Get the current PGN.
   */
  return function getPGN(options: JCE.Options.GeneratePgn = {}): string {
    const { game } = context;

    // useResultHeader: true defers all control of the 'Result' header to this API.
    return game.pgn({
      ...options,
      useResultHeader: true,
    });
  };
}
